import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import SidebarSection from 'components/Shared/Sidebar/SidebarSection/Index'
import SidebarText from 'components/Shared/Sidebar/SidebarText/Index'
import InlineSelect from 'components/Shared/InlineSelect/Index'
import ColorCircle from 'components/Shared/ColorCircle/Index'

const SidebarStatusSection = ({ ticket }) => {
  const { t } = useTranslation()

  const status = ticket?.partnerStatus

  // no data
  if (!status) {
    return (
      <SidebarSection title={t('sidebar.statusSection')}>
        <SidebarText />
      </SidebarSection>
    )
  }

  const statusOptions = [{ label: status, value: status }]

  const iconComponentsMap = {}
  statusOptions.forEach(statusOption => {
    const color = ticket.partnerStatusColors.find(v => v.name === statusOption.value).color
    iconComponentsMap[statusOption.value] = <ColorCircle color={color} />
  })

  return (
    <SidebarSection title={t('sidebar.statusSection')} copyText={status}>
      <InlineSelect
        disabled
        value={status}
        onChange={() => {}}
        options={statusOptions}
        iconComponentsMap={iconComponentsMap}
      />
    </SidebarSection>
  )
}

SidebarStatusSection.propTypes = {
  ticket: PropTypes.object,
}

export default SidebarStatusSection
